import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#why' },
  { label: 'Areas Served', href: '#areas' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between py-7">
        {/* Logo */}
        <a href="#hero" onClick={() => handleNavClick('#hero')} className="cursor-pointer flex items-center gap-4">
          <div className="w-24 h-24 flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/6645531746f64686987a03e27da8ae74/16f64b1b2195676dda194d0cc4a4f313.jpeg"
              alt="Butler Frelix Construction LLC Logo"
              className="w-24 h-24 object-contain rounded-md"
            />
          </div>
          <div className="hidden sm:block">
            <div className={`font-bold text-xl leading-tight tracking-wide ${scrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: "'Oswald', sans-serif" }}>
              BUTLER FRELIX
            </div>
            <div className="text-sm tracking-widest" style={{ fontFamily: "'Inter', sans-serif", color: '#ff2020' }}>
              CONSTRUCTION LLC
            </div>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`text-base font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap hover:text-red-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick('#contact')}
            className="bg-red-700 hover:bg-red-800 text-white text-base font-semibold px-7 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Get Free Quote
          </button>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl ${scrolled ? 'text-gray-900' : 'text-white'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 pb-4">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="block w-full text-left py-3 text-gray-800 font-medium text-sm border-b border-gray-50 cursor-pointer hover:text-red-600 transition-colors whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#contact')}
            className="mt-3 w-full bg-red-700 hover:bg-red-800 text-white font-semibold py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Get Free Quote
          </button>
        </div>
      )}
    </header>
  );
}
